export default class Scroll {
    static init(): void {
        const scrollTargets = document.querySelectorAll('[data-scroll]');

        if (scrollTargets.length === 0) {
            return;
        }

        scrollTargets.forEach((scrollTarget) => {
            scrollTarget.addEventListener('click', (event) => {
                event.preventDefault();
                const targetId = scrollTarget.getAttribute('data-scroll');
                if (targetId === null) {
                    return;
                }

                const target = document.getElementById(targetId);
                if (target) {
                    setTimeout(() => {
                        target.scrollIntoView({
                            behavior: 'smooth',
                        });
                    }, 500);
                }
            });
        });
    }
}
